import Vue from 'vue'
import Vuex from 'vuex'
import home from './modules/home/home.js'
import faq from './modules/company/faq.js'
import contact from './modules/company/contactus.js'
import address from './modules/home/address.js'
import category from './modules/category.js'
import outlet from './modules/company/outlet.js'
import product from './modules/product/product'
import profileLogin from './modules/profile/login'
import customer from './modules/profile/customer'
import cart from './modules/cart'
import order from './modules/order/'
import custmoize from './modules/customize'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export function CreateStore () {
  return new Vuex.Store({
    modules: {
      home,
      faq,
      contact,
      address,
      category,
      outlet,
      product,
      profileLogin,
      customer,
      cart,
      order,
      custmoize
    },
    strict: debug
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js